import { rolePermissionTypes } from "../types/rolePermissionTypes";
// import { userPermissionTypes } from "../types/userPermissionTypes";
import { Dispatch } from 'redux';
import { ThunkDispatch } from 'redux-thunk'
import { GET, POST, PUT, DELETE } from '../../utils/axios';
import moment from 'moment';
// import { maptoTruckDriverTable } from "../../scenes/TruckDriver/component/commonFn";



export const getRoleData = () => {
    return async (dispatch: Dispatch) => {
        const res = await roleDataApiReq();
        dispatch(setRole(res));
        return res;
    };
}

const setRole = (apiData: any) => {
    return {
        type: rolePermissionTypes.ROLE_DATA,
        payload: apiData,
    };
};

const setRolePermission = (apiData: any) => {
    return {
        type: rolePermissionTypes.ROLE_PERMISSION_DATA,
        payload: apiData,
    };
};
const setUserPermissionLoading = () => ({
    type: rolePermissionTypes.USER_PERMISSION_LOADING
  });
  
  const setUserPermissionLoaded = () => ({
    type: rolePermissionTypes.USER_PERMISSION_LOADED
  });
  
export const roleDataApiReq = async () => {
    try {

        let res = await GET(`/roles`)

        if (res) {
            return res.filter((role: any) => role.id !== 1); // Exclude role with ID 1
        }
        return [];
    } catch (err) {
        return [];
    }
};

export const getAllowedRoleData = (roleId:any,userId:any) => {
    return async (dispatch: Dispatch) => {
        const res = await allowedRoleDataApiReq(roleId,userId);
        dispatch(setRole(res));
        return res;
    };
}

export const allowedRoleDataApiReq = async (roleId:any,userId:any) => {
    try {

        let res = await GET(`/users/allowed-roles/${userId}/${roleId}`)

        if (res) {
            return res;
        }
        return [];
    } catch (err) {
        return [];
    }
};

export const addRole = (postData: any, id: any, type: any) => {
    return async (dispatch: Dispatch) => {
        const res = await addRoleReq(postData, id, type);
        dispatch(setRole(res));
        return res;
    }
}


export const addRoleReq = async (postData: any, id: any, type: any) => {
    try {
        if (type === "edit") {
            let res = await PUT(`/roles/${id}`, postData)
            return res;

        }
        let res = await POST('/roles', postData)
        return res;
    } catch (err) {
        return [];
    }
}


export const getPermissionData = (id: any) => {
    return async (dispatch: Dispatch) => {
        const res = await PermissionDataApiReq(id);
        dispatch(setRolePermission(res));
        return res;
    };
}

export const PermissionDataApiReq = async (id: any) => {
    try {

        let res = await GET(`/roles/v2/permissions/${id}`)

        if (res) {
            return res;
        }
        return [];
    } catch (err) {
        return [];
    }
};


export const addPermission = (postData: any) => {
    return async (dispatch: Dispatch) => {
        const res = await addPermissionReq(postData);
        dispatch(setRolePermission(res));
        return res;
    }
}


export const addPermissionReq = async (postData: any) => {
    try {
        let res = await POST(`/roles/v2/permissions/${postData.roleId}`, postData)
        return res;
    } catch (err) {
        return [];
    }
}


//users
const setUser = (apiData: any) => {
    return {
        type: rolePermissionTypes.USER_DATA,
        payload: apiData,
    };
};

export const setUserPermission = (apiData: any) => {
    return {
        type: rolePermissionTypes.USER_PERMISSION_DATA,
        payload: apiData,
    };
};

export const getUserData = () => {
    return async (dispatch: Dispatch) => {
        const res = await userDataApiReq();
        dispatch(setUser(res));
        return res;
    };
}

export const userDataApiReq = async () => {
    try {

        let res = await GET(`/users/all`)

        if (res) {
            return res;
        }
        return [];
    } catch (err) {
        return [];
    }
};

export const addUser = (postData: any, id: any, type: any) => {
    return async (dispatch: Dispatch) => {
        const res = await addUserReq(postData, id, type);
        dispatch(setRole(res));
        return res;
    }
}


export const addUserReq = async (postData: any, id: any, type: any) => {
    try {
        if (type === "edit") {

            let res = await PUT(`/users/${id}`, postData)
            return res;

        }
        let res = await POST('/users/create-user', postData)
        return res;
    } catch (err) {
        return [];
    }
}

// export const getUserPermissionData = (id: any) => {
//     return async (dispatch: Dispatch) => {
//         const res = await userPermissionDataApiReq(id);
//         dispatch(setUserPermission(res));
//         return res;
//     };
// }
export const getUserPermissionData = (id: any) => {
    return async (dispatch: Dispatch) => {
      dispatch(setUserPermissionLoading());
  
      try {
        const res = await userPermissionDataApiReq(id);
        dispatch({
          type: rolePermissionTypes.USER_PERMISSION_DATA,
          payload: res || {}
        });
        return res;
      } catch (error) {
        dispatch(setUserPermissionLoaded());
        return {};
      }
    };
  };

export const userPermissionDataApiReq = async (id: any) => {
    try {

        let res = await GET(`/users/permissions/${id}`)

        if (res) {
            return res;
        }
        return [];
    } catch (err) {
        return [];
    }
};

